var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.125,
    height: 15,
    viewBox: "0 0 13.125 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M3.961.394,3.75.813H.938a.938.938,0,0,0,0,1.875h11.25a.938.938,0,0,0,0-1.875H9.375L9.164.394a.934.934,0,0,0-.838-.519H4.8A.934.934,0,0,0,3.961.394Zm8.227,3.231H.937l.621,9.932a1.407,1.407,0,0,0,1.4,1.318h7.2a1.407,1.407,0,0,0,1.4-1.318Z",
    transform: "translate(0 0.125)",
    fill: "#bcbcbc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.442acbf1145b7ce7fa5ca26954cf6916.svg";
export { ForwardRef as ReactComponent };